import React from 'react';
import PropTypes from 'prop-types';

// this indicates whether to change from 'fas' to 'far'
// 'fas' is generally heavier - "Solid"
// 'far' is lighter, "regular"
// Not all are available in non-pro version.  In general, the solid
// version is available.

// must be defined outside of the component to avoid re-rendering loops
const defaultStyle = {};
const Icon = _ref => {
  let _ref$weight = _ref.weight,
    weight = _ref$weight === void 0 ? 'fas' : _ref$weight,
    glyph = _ref.glyph,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? defaultStyle : _ref$style,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? null : _ref$ariaLabel;
  return /*#__PURE__*/React.createElement("i", {
    "aria-label": ariaLabel || glyph,
    className: "".concat(weight, " fa-").concat(glyph).concat(className ? " ".concat(className) : ''),
    style: style
  });
};
Icon.propTypes = {
  glyph: PropTypes.string.isRequired,
  /* eslint-disable react/forbid-prop-types */
  style: PropTypes.shape({}),
  weight: PropTypes.string,
  className: PropTypes.string,
  ariaLabel: PropTypes.string
};
export default Icon;